module.exports = __webpack_public_path__ + "e4a7ee09801b24adbdcc207a6c0cdd49.png";